import { FC } from 'react';
import { useTheme } from 'styled-components';
import { TextIcon } from 'components/Base/TextIcon';
import { Icon } from 'components/Base/Icon';
import { TActionGroupItemLabelProps } from './ActionGroupItemLabel.types';

const ActionGroupItemLabel: FC<TActionGroupItemLabelProps> = ({
  icon,
  label,
  onClick,
  disabled = false,
}) => {
  const theme = useTheme();
  const alt = `${icon}-icon`;
  return (
    <TextIcon
      {...(icon && {
        icon: (
          <Icon
            icon={icon}
            alt={alt}
            color={theme.colorBlackPrimary}
            size={16}
          />
        ),
      })}
      label={label}
      alt={alt}
      strong={false}
      color={theme.colorBlackPrimary}
      fontWeight={theme.fontWeightRegular}
      {...(!disabled && onClick && { onClick })}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.5 : 1,
      }}
    />
  );
};

export default ActionGroupItemLabel;
